import React, { useMemo } from 'react';
import { Empty } from 'antd';
import { isEmpty } from 'lodash';
import moment from 'moment';

import DualAxisAreaChart from '../../../../../../shared/designSystem/components/DualAxisAreaChart';

// =============================================================================
// SignUpsV2Chart — single-axis sign-ups-over-time trend.
//
// Migrated from BizCharts (via the shared SingleAxisArea) to the shared
// Recharts DualAxisAreaChart with `rightY="None"` — the primitive already
// supports single-axis mode. Kept the component name stable so parents
// (SignUpsV2Layout) don't have to change.
//
// Data shape: rows with { date, signups }. Normalized here to
// { xAxis: YYYY-MM-DD, signUps } so DualAxisAreaChart's labelToKey
// ("Sign Ups" → "signUps") finds the right field.
// =============================================================================

const SignUpsV2Chart = ({ data }) => {
  const rows = useMemo(() => {
    if (isEmpty(data)) return [];
    return data
      .map((row) => ({
        xAxis: moment(row.date).isValid()
          ? moment(row.date).format('YYYY-MM-DD')
          : row.date,
        signUps: Number(row.signups) || 0,
      }))
      .sort((a, b) => moment(a.xAxis).diff(moment(b.xAxis)));
  }, [data]);

  if (isEmpty(rows)) {
    return (
      <div
        className="campaign-overview__chart"
        style={{ padding: '32px 20px', display: 'flex', justifyContent: 'center' }}
      >
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No signup data yet" />
      </div>
    );
  }

  return (
    <div className="campaign-overview__chart">
      <div className="campaign-overview__chart-head">
        <div className="campaign-overview__chart-eyebrow mono-eyebrow">
          Trend
        </div>
      </div>
      <div className="campaign-overview__chart-body">
        <DualAxisAreaChart
          dualChartData={rows}
          leftY="Sign Ups"
          rightY="None"
        />
      </div>
    </div>
  );
};

export default SignUpsV2Chart;
